import { defineStore } from "pinia";
import { getValueMappings, getMapMappings } from "@/api/myProject";

interface GlobalConfigState {
  valueMappings: any;
  mapMappings: any;
  isLoaded: boolean;
  isLoading: boolean;
}

export const useGlobalConfigStore = defineStore("globalConfig", {
  state: (): GlobalConfigState => ({
    valueMappings: null,
    mapMappings: null,
    isLoaded: false,
    isLoading: false
  }),

  actions: {
    /**
     * 由于这个接口在项目中使用多次导致部分业务出错 修改成只调用一次
     * 如果真实需要更新配置的时候调用 reFetchConfigs 函数
     * check 阻止多余请求
     */
    async fetchConfigs(check = true) {
      if (check && this.mapMappings && this.valueMappings) return;
      if (this.isLoaded || this.isLoading) {
        return;
      }

      this.isLoading = true;
      try {
        // 检查用户是否已登录
        const { getToken } = await import("@/utils/auth");
        const token = getToken();

        if (!token) {
          this.isLoading = false;
          return;
        }

        // 并行获取两个配置
        const [valueRes, mapRes] = await Promise.all([
          getValueMappings({}),
          getMapMappings({})
        ]);

        if (valueRes && valueRes.success) {
          this.valueMappings = valueRes.result;
        }

        if (mapRes && mapRes.success) {
          this.mapMappings = mapRes.result;
        }

        this.isLoaded = true;
      } catch {
        this.isLoaded = false;
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 重新请求配置参数 本次请求必定会发送
     */
    reFetchConfigs() {
      this.fetchConfigs(false);
    },

    // 解析动态表单字段
    getDynamicFormFields() {
      if (!this.mapMappings) return [];

      const allFields = [];
      Object.entries(this.mapMappings).forEach(
        ([sectionKey, sectionData]: [string, any]) => {
          if (!sectionData || typeof sectionData !== "object") return;

          Object.entries(sectionData).forEach(
            ([key, fieldConfig]: [string, any]) => {
              if (fieldConfig.type === "block" || key === "block") {
                // 处理block字段
                if (fieldConfig.fields && Array.isArray(fieldConfig.fields)) {
                  fieldConfig.fields.forEach((blockField: any) => {
                    allFields.push({
                      key: blockField.fieldName,
                      label: blockField.desc,
                      type: blockField.type,
                      promotionType: sectionKey.toUpperCase(),
                      isBlockField: true
                    });
                  });
                }
              } else if (fieldConfig.desc && fieldConfig.type) {
                // 处理普通字段
                allFields.push({
                  key: key,
                  label: fieldConfig.desc,
                  type: fieldConfig.type,
                  promotionType: sectionKey.toUpperCase(),
                  isBlockField: false
                });
              }
            }
          );
        }
      );

      return allFields.filter(item => {
        // 过滤掉不需要显示的字段
        const hiddenFields = ["promotionId", "relatedTableId", "baseTableId"];
        return !hiddenFields.includes(item.key);
      });
    }
  }
});
